import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'
import type { ReconcileSummary } from './types'

/** GET /reconcile/summary — dùng chung cho trang Đối soát và ô tiền trên Tổng quan Đại lý / CTV. */
export function useReconcileSummary() {
  return useQuery({ queryKey: ['reconcile', 'summary'], queryFn: () => get<{ summary: ReconcileSummary }>('/reconcile/summary') })
}
